import React from "react";

// import ErrorIcon from "@common/assets/images/error.png";
// import { ReactComponent as WarningIcon } from "@common/assets/images/warning.svg";
import Heading from "@common/components/Heading/Heading";
import Paragraph from "@common/components/Paragraph/Paragraph";
import { Spinner } from "@common/components/Spinner/Spinner";
import { vars } from "@common/styles";
import { docLink } from "@common/util/docs";
import { useAppSelectionContext } from "@main/context/App/AppSelectionContext";
import useNetworkSpeedData from "@main/pages/Release/consumers/useNetworkSpeedData";
import { MetricCardEmptyState } from "@main/pages/Release/views/MetricCards/MetricCardEmptyState";
import { EndpointUrl } from "@main/pages/Release/views/MetricDetails/shared/EndpointUrl";
import * as MetricDetailsStyled from "main/pages/Release/views/MetricDetails/MetricDetails.styles";
import * as Styled from "main/pages/Release/views/MetricDetails/NetworkSpeed/NetworkSpeedDataView.styles";

export default function NetworkSpeedDataView() {
  const { endpoints, isLoading } = useNetworkSpeedData();

  const { selectedApp } = useAppSelectionContext();
  const platform = selectedApp?.platform?.name;

  const isEmpty = !endpoints || endpoints.length === 0;

  if (isLoading) {
    return <Spinner />;
  }

  return (
    <div style={{ padding: "3.2rem 0" }}>
      <MetricDetailsStyled.MetricsCard>
        <Heading
          heading3
          marginBottom={24}
        >
          Data
        </Heading>
        <Paragraph
          p1
          style={{ color: vars.colors.grey60, marginBottom: "0.4rem" }}
        >
          All endpoints are listed below.
        </Paragraph>
        <Paragraph
          p1
          style={{ color: vars.colors.grey60, marginBottom: "2.4rem" }}
        >
          The P95 metric is used to express endpoint speed, meaning that 95% of requests were completed in less than
          that amount of time.
        </Paragraph>
        {!isEmpty ? (
          <Styled.EndpointList>
            {endpoints?.map((endpoint, index) => (
              <Styled.EndpointRow key={`${endpoint.method}-${endpoint.url}-${index}`}>
                <Styled.EndpointScore
                  style={{ marginRight: "1.6rem" }}
                  score={endpoint.score}
                />
                <Paragraph
                  p2
                  style={{
                    marginRight: "1.2rem",
                    color: endpoint.isError ? vars.colors.red : vars.colors.white,
                  }}
                >
                  {`${endpoint.time.toFixed(0)} ms`}
                </Paragraph>
                <div style={{ marginRight: "0.8rem" }}>
                  <Styled.Badge $isError={endpoint.isError}>{endpoint.method}</Styled.Badge>
                </div>
                {/*{endpoint.isError ? (*/}
                {/*  <Styled.ErrorIconWrapper>*/}
                {/*    <img*/}
                {/*      src={ErrorIcon}*/}
                {/*      alt="error"*/}
                {/*    />*/}
                {/*  </Styled.ErrorIconWrapper>*/}
                {/*) : (*/}
                {/*  endpoint.showWarning && (*/}
                {/*    <Styled.WarningIconWrapper>*/}
                {/*      <WarningIcon />*/}
                {/*    </Styled.WarningIconWrapper>*/}
                {/*  )*/}
                {/*)}*/}
                <EndpointUrl
                  url={endpoint.url}
                  isError={endpoint.isError}
                />
              </Styled.EndpointRow>
            ))}
          </Styled.EndpointList>
        ) : (
          <MetricCardEmptyState
            text={"No network traffic recorded yet. If you haven't already, enable it in your SDK."}
            buttonText={"Enable network traffic"}
            onButtonClick={() => window.open(docLink(platform).networkTraffic, "_blank")?.focus()}
            column
          />
        )}
      </MetricDetailsStyled.MetricsCard>
    </div>
  );
}
